module.exports = __webpack_public_path__ + "media/glycolic-large.5ee5657c.mp4";